import { render, staticRenderFns } from "./FormSelectFetchAPIInput2.vue?vue&type=template&id=53f2b4e7&scoped=true&"
import script from "./FormSelectFetchAPIInput2.vue?vue&type=script&lang=js&"
export * from "./FormSelectFetchAPIInput2.vue?vue&type=script&lang=js&"
import style0 from "./FormSelectFetchAPIInput2.vue?vue&type=style&index=0&id=53f2b4e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2b4e7",
  null
  
)

export default component.exports